import { render, staticRenderFns } from "./RsaSchedaAnamnesiaStoriaClinicaModalEditComponent.vue?vue&type=template&id=4066b9b0"
import script from "./RsaSchedaAnamnesiaStoriaClinicaModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAnamnesiaStoriaClinicaModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports